jQuery(document).ready(function(){
  var promoCode = 'FREECARDS';
  var cookieName = 'cardfree';
  var defaultCartPrice = 25;
  var freeProID = 8003375464706;
  var freeProVariantID = 43673210061058;
  var cookieExpiryDay = 7;
  
  var getSavedCookie = getCookieFromBrowser(cookieName);;
  var getParams = new URLSearchParams(window.location.search);
  if(getParams.get('cc') === 'new' && getSavedCookie == false){
       var cookieValue = "cc_new";
      var date = new Date();
      date.setTime(date.getTime()+(1*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
      document.cookie = cookieName+"="+cookieValue+expires+"; path=/";
      jQuery('.free-gift-progress-notifiy').css('display', 'block'); 
  }
  
  //getCartItems(true, freeProID, freeProVariantID, defaultCartPrice, getSavedCookie, promoCode, 'load');
  jQuery(document).on('click', 'button.product-form__submit', function(){
    //getCartItems(true, freeProID, freeProVariantID, defaultCartPrice, getSavedCookie, promoCode, 'addtocart')
  });
  jQuery(document).on('click', 'button.quantity__button',function(){
    //getCartItems(true, freeProID, freeProVariantID, defaultCartPrice, getSavedCookie, promoCode, 'minsplus');
  });
  jQuery(document).on('click', '.button.button--tertiary, .button.button--tertiary', function(){
    //getCartItems(true, freeProID, freeProVariantID, defaultCartPrice, getSavedCookie, promoCode, 'removecart');
  });

  function getCartItems(status, productID, productVariantID, defaultCartPrice, cookieStatus, promoCode, request){
    if(cookieStatus){
      setTimeout(()=> {
          fetch('/cart.json')
          .then(response => response.json())
          .then(res => {
              if(res.item_count > 0 && status){

                var formatter = new Intl.NumberFormat('en-US', {style: 'currency',currency: res.currency});
                var cartPrice = parseInt(res.total_price / 100) + "." + (res.total_price % 100);
                
                var proPrice = res.items.find((obj) => obj.id === productVariantID);
                proPrice = (typeof proPrice != 'undefined') ? proPrice.discounted_price : 0;

                var addedProPrice = parseInt(proPrice / 100) + "." + (proPrice % 100);
                var excludeProPrice = (proPrice != 0) ? (cartPrice - addedProPrice) :  cartPrice;
                
                if(excludeProPrice > defaultCartPrice){ 
                  var matchProductStatus = res.items.find((obj) => obj.id === productVariantID);
                  if(typeof matchProductStatus == 'undefined') { 
                    addFreeProduct(productID, productVariantID, promoCode, request);
                  }
                }else{
                  removeFreeProduct(productID, productVariantID, request);
                }

                var calculate = (cartPrice / defaultCartPrice * 100);
                var diffAmount = (defaultCartPrice - cartPrice);
                var replaceAmount = formatter.format(diffAmount);
                if(calculate >= 100){
                  jQuery('.free-gift-progress-notifiy').css('display', 'none');
                }else{
                  jQuery('.free-gift-progress-notifiy').css('display', 'block');
                  jQuery('.free-gift-progress-notifiy .notifiy-price').text(replaceAmount);
                }
              }else{
                jQuery('.free-gift-progress-notifiy').css('display', 'block'); 
                jQuery('.cart-count-bubble span:first').text(res.item_count);
                jQuery('.cart-count-bubble span:last').text(`${res.item_count} items`);
              }
          });
      }, 1000);
    }
  }
  function addFreeProduct(productID, productVariantID, promoCode, request){
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({'items':[{'id':  productVariantID, 'product_id': productID, 'quantity': 1, properties: {'discount_code': promoCode}}]})
    }).then(response => {
        return response.json();
    }).then( res => { 
      addDiscountCoupon(promoCode);
      reloadCurrentPage(request);
    }).catch((error) => console.error('Error:', error) );
  }
  function removeFreeProduct(productID, productVariantID, request){
    setTimeout(function(){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({"quantity": "0","id": ""+productVariantID+""})
    }).then(response => {
        return response.json();
    }).then( res => {
        reloadCurrentPage(request);
    }).catch((error) => console.error('Error:', error) );
    }, 1000);
  }
  function addDiscountCoupon(promoCode) {
    fetch(`/discount/${promoCode}`).then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({updates: {}}),
      });
    }).catch(function(error) { console.error('Error:', error);});
  }
  function reloadCurrentPage(request) {
    if(request == 'minsplus' || request == 'removecart'){
      var removeInterval = setTimeout(function() { 
        clearInterval(removeInterval); 
        location.reload(true); 
      }, 1000);
    }
    
  }
  function getCookieFromBrowser(cookieName){
    var cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      var [name, value] = cookie.split('=');
      if (jQuery.trim(cookieName) == jQuery.trim(name)) { return true; }
    }
    return false;
  }
});